var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistrust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36588_127411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92031 3.67689C1.92031 3.5212 2.01138 3.37991 2.15317 3.31561L5.48955 1.80253C7.0856 1.07871 8.91635 1.07871 10.5124 1.80254L13.8488 3.31561C13.9906 3.37991 14.0816 3.5212 14.0816 3.67689V7.48553C14.0816 11.1873 11.5891 14.425 8.01042 15.3717C8.00423 15.3734 7.99772 15.3734 7.99154 15.3717C4.41288 14.425 1.92031 11.1873 1.92031 7.48552V3.67689Z",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2559 5.77173L5.69764 10.3299",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2554 10.3296L5.69716 5.77137",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36588_127411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16 16) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistrust);
export default __webpack_public_path__ + "static/media/distrust.86f63cc6f8ff9eb51f77e215df7258d8.svg";
export { ForwardRef as ReactComponent };